export default "__VITE_ASSET__CR7x7zYz__"